import React from 'react'
// import ReservationSegmentBuilderSummary from '../ReservationSegmentBuilderSummary'
// import DataTable from '../../DataTable/DataTable'
import ReservationBuilderSegmentSummary from '../../ReservationBuilder/ReservationBuilderSegmentSummary'
// import ReservationBuilderTotal from "../../ReservationBuilder/ReservationBuilderTotal"
// import Switch from '../../Switch/Switch'

export default class ReservationSegmentBuilderConfirm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    
    return (
      <div className="reservation-builder">
        <div className="confirm-finish">
          {this.renderErrors()}

          <div className="row">

            <div className="col-md-12">


              <div className="summary-of-charges">
                <h3 className="panel-heading-text">{I18n.t('summary_of_charges')}</h3>
                <div className="segments">
                <ReservationBuilderSegmentSummary edit_reservation_segment_folio_items_data_table_path={this.props.edit_reservation_segment_folio_items_data_table_path} key={this.props.reservation_segment.temp_id || this.props.reservation_segment.id} {...this.props} segment={this.props.reservation_segment} date_format={this.props.date_format} open={true}/>
                  {/* <ReservationSegmentBuilderSummary edit_reservation_segment_folio_items_data_table_path={this.props.edit_reservation_segment_folio_items_data_table_path} key={this.props.reservation_segment.temp_id || this.props.reservation_segment.id} {...this.props} segment={this.props.reservation_segment} date_format={this.props.date_format} /> */}
                </div> 
    
              </div>


              {/* <ReservationBuilderTotal reservation={this.props.reservation_segment}  /> */}
             </div>
          </div>

        </div>

      </div>
    )
    
  };

  renderErrors() {
    var errors = this.props.errors;

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return(
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
};
